import axios from 'axios'
import { toast } from 'react-toastify'
import {
  call,
  spawn,
  put,
} from 'redux-saga/effects'

import {
  POINTS_CREATE_CACHE_START,
  POINTS_CREATE_CACHE_SUCCEEDED,
} from './points.actions'

export default {
  * createCacheAndGoTo({ payload }) {
    try {
      yield put(POINTS_CREATE_CACHE_START())
      const { profile, point, link } = payload

      yield call(axios.post, '/api/points/cache', {
        point_id: point._id,
      })

      yield spawn(
        [window, window.open],
        `${link}/${profile._id}/${point._id}`,
        '_blank',
      )
    } catch (error) {
      const { title } = payload

      yield spawn(
        [toast, toast.warn],
        `Hubo un error al cargar ${title}. Por favor reintente.`,
      )
    } finally {
      yield put(POINTS_CREATE_CACHE_SUCCEEDED())
    }
  },
}
